module.exports = "/assets/9f3345c0b5cb3f7618684a65e67295c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/5L.png
// module id = 1063
// module chunks = 0